module.exports = __webpack_public_path__ + "static/media/square.6c713185.svg";